import React from 'react';
import type { NoSectionAccessProps } from './types';

/**
 * Empty-state shown in place of a section's content when the persisted backend access decision
 * says the current user has no right to it (see backend TenantSectionAccessEntity) — e.g. on Home
 * when Relance client is inaccessible, or on the History page when reached directly without the
 * right. Callers own the copy (already translated) so this component stays feature-agnostic.
 */
export const NoSectionAccess: React.FC<NoSectionAccessProps> = ({ title, message, testId = 'no-section-access' }) => (
    <div
        data-testid={testId}
        role="status"
        aria-live="polite"
        className="flex flex-col items-center gap-s rounded-md border border-line-subtle bg-primary-100 px-l py-2xl text-center"
    >
        <p className="text-s font-semibold text-primary-900">{title}</p>
        <p className="text-s text-primary-700">{message}</p>
    </div>
);
